import React from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import ModalButton from "../ModalButton";
import SelectField from "../../Base/ui/inputs/SelectField";
import BooleanField from "../../Base/ui/inputs/BooleanField";

const MedicinalMarijuanaListView = ({ medicinalMarijuana }) => {
  return (
    <>
      <Row>
        <BooleanField
          value={medicinalMarijuana.maintenance_card}
          action="show"
          label="Maintenance Card"
        />
        <BooleanField
          value={medicinalMarijuana.maintenance_card_for_pain_management}
          action="show"
          label="Maintenance Card for Pain Management"
        />
          <SelectField
              value={medicinalMarijuana.form_of_usage}
              action="show"
              label="Form of Usage"
          />
      </Row>
      <div className="d-flex justify-content-center">
        <ModalButton
          resourceName="medicinalMarijuana"
          resource={medicinalMarijuana}
          label="Add/Edit Medicinal Marijuana"
        />
      </div>
    </>
  );
};
const mapStateToProps = (state, _) => {
  return {
    isStaffApp: state.config.isStaffApp,
    medicinalMarijuana: state.medicinal_marijuana,
  };
};

export default connect(mapStateToProps, _)(MedicinalMarijuanaListView);
